import DOMPurify from 'dompurify';

/**
 * Sanitize CMS HTML before rendering to mitigate XSS.
 * @param {string} html
 * @returns {string}
 */
export const sanitizeHtml = (html = '') => {
  if (typeof window === 'undefined') return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });
};
